module.exports = __webpack_public_path__ + "static/media/verdeInternal_wide.09b5a416.jpg";